<template>
    <div class="pop_overlay_black" v-if="isShow">
        <div class="pop_wrap rsv2_manager_set_pop" style="width: 940px;">
            <div v-if="isLoading" class="loading_bg" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_title">
                <span class="title">AI 예약 알림 설정</span>
                <button class="mgl_auto" @click="action_Close"><v-icon large>mdi-close</v-icon></button>
            </div>
            <div class="pop_desc lgray black_txt">
                알림톡은 직접 설정으로 알림톡 내용을 수정하시는 경우 카카오에서 승인받은 후 발송됩니다.
                <br/>
                승인되기 전까지 기본 설정값으로 발송됩니다.
            </div>
            <div class="pop_cont">
                <div class="rsv_msg_wrap">
                    <div class="rsv_msg_txt_set" style="width: 575px; height: 500px; overflow-y: auto;">
                        <table class="msg_edit_table">
                            <colgroup>
                                <col style="width: 130px;">
                                <col>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>항목</th>
                                    <th>알림 내용</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="title">AI 예약 시</td>
                                    <td>
                                        <div class="radio_wrapper">
                                            <label class="radio_wrap">
                                                <input type="radio" v-model="group.usingCustomAIImmediateCreate" :value="false">
                                                <span class="checkmark"/>기본 설정
                                            </label>
                                            <label class="radio_wrap">
                                                <input type="radio" v-model="group.usingCustomAIImmediateCreate" :value="true">
                                                <span class="checkmark"/>직접 설정
                                            </label>
                                        </div>
                                        <textarea
                                            v-if="!group.usingCustomAIImmediateCreate"
                                            class="textarea w_full"
                                            rows="5"
                                            v-model="group.messageAIImmediateCreate"
                                            disabled
                                            placeholder="AI 예약 시 발송될 메시지를 입력해주세요."
                                        ></textarea>
                                        <textarea
                                            v-if="group.usingCustomAIImmediateCreate"
                                            class="textarea w_full"
                                            rows="5"
                                            v-model="group.customMessageAIImmediateCreate"
                                            placeholder="AI 예약 시 발송될 메시지를 입력해주세요."
                                            @focus="handleTextareaFocus($event, 'create')"
                                        ></textarea>
                                        <div class="txt_right mgt_5">
                                            <a class="btn btn_underline blue_txt" @click="showPreview('create')">{{ $t('reservation_settings.popup_group_settings.label_preview') }}</a>
                                        </div>
                                        <div class="kakao_status_wrap" v-if="usingKakaoAlrimtalk">
                                            <span class="kakao_status" :class="craeteKakaoStatus.class">{{ craeteKakaoStatus.name }}</span>
                                            <span>{{ craeteKakaoStatus.description }}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="title">예약 확정 시</td>
                                    <td>
                                        <div class="radio_wrapper">
                                            <label class="radio_wrap">
                                                <input type="radio" v-model="group.usingCustomAIConfirmation" :value="false">
                                                <span class="checkmark"/>기본 설정
                                            </label>
                                            <label class="radio_wrap">
                                                <input type="radio" v-model="group.usingCustomAIConfirmation" :value="true">
                                                <span class="checkmark"/>직접 설정
                                            </label>
                                        </div>
                                        <textarea
                                            v-if="!group.usingCustomAIConfirmation"
                                            class="textarea w_full"
                                            rows="5"
                                            v-model="group.messageAIConfirmation"
                                            disabled
                                            placeholder="AI 예약 확정 시 발송될 메시지를 입력해주세요."
                                        ></textarea>
                                        <textarea
                                            v-if="group.usingCustomAIConfirmation"
                                            class="textarea w_full"
                                            rows="5"
                                            v-model="group.customMessageAIConfirmation"
                                            placeholder="AI 예약 시 발송될 메시지를 입력해주세요."
                                            @focus="handleTextareaFocus($event, 'confirm')"
                                        ></textarea>
                                        <div class="txt_right mgt_5">
                                            <a class="btn btn_underline blue_txt" @click="showPreview('confirm')">{{ $t('reservation_settings.popup_group_settings.label_preview') }}</a>
                                        </div>
                                        <div class="kakao_status_wrap" v-if="usingKakaoAlrimtalk">
                                            <span class="kakao_status" :class="confirmKakaoStatus.class">{{ confirmKakaoStatus.name }}</span>
                                            <span>{{ confirmKakaoStatus.description }}</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="title">예약 삭제 시</td>
                                    <td>
                                        <div class="radio_wrapper">
                                            <label class="radio_wrap">
                                                <input type="radio" v-model="group.usingCustomAIRemove" :value="false">
                                                <span class="checkmark"/>기본 설정
                                            </label>
                                            <label class="radio_wrap">
                                                <input type="radio" v-model="group.usingCustomAIRemove" :value="true">
                                                <span class="checkmark"/>직접 설정
                                            </label>
                                        </div>
                                        <textarea
                                            v-if="!group.usingCustomAIRemove"
                                            class="textarea w_full"
                                            rows="5"
                                            v-model="group.messageAIRemove"
                                            disabled
                                            placeholder="AI 예약 시 발송될 메시지를 입력해주세요."
                                        ></textarea>
                                        <textarea
                                            v-if="group.usingCustomAIRemove"
                                            class="textarea w_full"
                                            rows="5"
                                            v-model="group.customMessageAIRemove"
                                            placeholder="AI 예약 시 발송될 메시지를 입력해주세요."
                                            @focus="handleTextareaFocus($event, 'remove')"
                                        ></textarea>
                                        <div class="txt_right mgt_5">
                                            <a class="btn btn_underline blue_txt" @click="showPreview('remove')">{{ $t('reservation_settings.popup_group_settings.label_preview') }}</a>
                                        </div>
                                        <div class="kakao_status_wrap" v-if="usingKakaoAlrimtalk">
                                            <span class="kakao_status" :class="removeKakaoStatus.class">{{ removeKakaoStatus.name }}</span>
                                            <span>{{ removeKakaoStatus.description }}</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="rsv_msg_info relative">
                        <div class="txt_preview_wrap" v-if="isShowPreview">
                            <div class="txt_preview_top">
                                <span class="txt_preview_title">{{ $t('reservation_settings.popup_group_settings.label_preview_message') }}</span>
                                <a class="mgl_auto" @click="hidePreview"><v-icon small>mdi-close</v-icon></a>
                            </div>
                            <div class="txt_preview_cont">
                                <div class="bubble"><pre>{{ previewMessage }}</pre></div>
                            </div>
                        </div>
                        <table class="table2_default no_hover">
                            <colgroup>
                                <col width="115px">
                                <col width="">
                            </colgroup>
                            <tr>
                                <th colspan="2">
                                    {{ $t('reservation_settings.popup_group_settings.label_refer_to_placeholders') }}
                                    <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
                                    <span class="tooltip_wrap">
                                        <span class="tooltip">
                                            {{ $t('reservation_settings.popup_group_settings.label_refer_to_placeholders_description') }}
                                        </span>
                                    </span>
                                </th>
                            </tr>
                            <tr>
                                <th>{{ $t('reservation_settings.popup_group_settings.label_input') }}</th>
                                <th>{{ $t('reservation_settings.popup_group_settings.label_example_refer_to_placeholders') }}</th>
                            </tr>
                            <tr>
                    <td><span class="label lgray" v-pre>{{고객명}}</span></td>
                        <td>홍길동</td>
                    </tr>
                    <tr>
                        <td><span class="label lgray" v-pre>{{프로그램명}}</span></td>
                        <td>도수치료 A코스</td>
                    </tr>
                    <tr>
                        <td><span class="label lgray" v-pre>{{담당자명}}</span></td>
                        <td>이철수</td>
                    </tr>
                    <tr>
                        <td><span class="label lgray" v-pre>{{예약일시}}</span></td>
                        <td>2023년 07월 03일(월) 13:00</td>
                    </tr>
                    <tr>
                        <td><span class="label lgray" v-pre>{{예약일}}</span></td>
                        <td>2023년 07월 03일(월)</td>
                    </tr>
                    <tr>
                        <td><span class="label lgray" v-pre>{{시작시간}}</span></td>
                        <td>13:00</td>
                    </tr>
                    <tr>
                        <td><span class="label lgray" v-pre>{{종료시간}}</span></td>
                        <td>14:00</td>
                    </tr>
                        </table>
                    </div>
                </div>
                <div class="btn_wrap">
                    <button class="btn btn_l btn_dgray" @click="action_Close">{{ $t('common.cancel') }}</button>
                    <button class="btn btn_l btn_blue" @click="action_Save">{{ $t('common.save') }}</button>
                </div>
            </div>
        </div>
        <!-- 수정 알림 팝업 -->
        <EditAlertPopup v-if="isShowEditAlert" @hideAlert="hideEditAlert"/>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import EditAlertPopup from '../../GroupEditPopup/NoticeMessages/EditAlertPopup.vue'
import { useQueryClient } from '@tanstack/vue-query'
import { reservationGroupAiFindQueryOptions } from '@/composables/queries/reservationgroup/use-reservation-group-ai-find-query'
import { useReservationGroupAiUpdateMutation } from '@/composables/queries/reservationgroup/use-reservation-group-ai-update-mutation'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'

const emptyGroup = {
    title: undefined,
    hospitalID: undefined,

    usingCustomAIImmediateCreate: true,
    messageAIImmediateCreate: undefined,
    messageAIImmediateCreateHistoryID: undefined,
    customMessageAIImmediateCreate: undefined,
    customMessageAIImmediateCreateHistoryID: undefined,

    usingCustomAIConfirmation: true,
    messageAIConfirmation: undefined,
    messageAIConfirmationHistoryID: undefined,
    customMessageAIConfirmation: undefined,
    customMessageAIConfirmationHistoryID: undefined,

    usingCustomAIRemove: true,
    messageAIRemove: undefined,
    messageAIRemoveHistoryID: undefined,
    customMessageAIRemove: undefined,
    customMessageAIRemoveHistoryID: undefined,
}

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: mutateAiGroup } = useReservationGroupAiUpdateMutation()
        return { queryClient, mutateAiGroup }
    },
    components: { EditAlertPopup },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isLoading: false,
            pendingMessage: '',
            confirmedMessage: '',
            // 미리보기
            previewType: null, // 'pending' | 'confirmed'
            // 수정 알림 팝업
            isShowEditAlert: false,
            editAlertTarget: null, // 'create' | 'confirm' | 'remove'
            // 수정 확인 완료 여부 (한 번 '네' 클릭 후 반복 알림 방지)
            hasConfirmCreate: false,
            hasConfirmConfirm: false,
            hasConfirmRemove: false,

            // Group Data
            group: emptyGroup,
            originGroup: emptyGroup
        }
    },
    computed: {
        // 카카오 알림톡 사용 여부
        usingKakaoAlrimtalk: function() {
            return this.servicesetting?.setting?.hasKakaoAlimAndFriendTalkLinkage ?? false
        },
        // 상태 종류 정의
        statusKind: function() {
            return [
                // 사용가능
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available'), key: 'RDY', class: 'blue', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available_detail') },
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available'), key: 'ACT', class: 'blue', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available_detail') },
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available'), key: 'APR', class: 'blue', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available_detail') },
                // 검수신청
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review'), key: 'REG', class: '', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review_detail') },
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review'), key: 'REQ', class: '', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review_detail') },
                // 사용불가
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'), key: 'REJ', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail') },
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'), key: 'STP', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail') },
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'), key: 'DMT', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail_dormant') },
                { name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'), key: 'BLK', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail_blocked') },
                // 상태를 확인할 수 없음
                { name: '미존재', key: '-', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail_unknown') }
            ]
        },
        // 카카오 템플릿
        craeteKakaoStatus: function() {
            if (this.group.usingCustomAIImmediateCreate) {
                return this.statusKind.find( s => s.key === this.group.customMessageAIImmediateCreateHistoryID?.inspectionStatus ) ?? this.statusKind.find(s => s.key === '-')
            }
            else {
                return this.statusKind.find( s => s.key === this.group.messageAIImmediateCreateHistoryID?.inspectionStatus ) ?? this.statusKind.find(s => s.key === '-')
            }
        },
        confirmKakaoStatus: function() {
            if (this.group.usingCustomAIConfirmation) {
                return this.statusKind.find( s => s.key === this.group.customMessageAIConfirmationHistoryID?.inspectionStatus ) ?? this.statusKind.find(s => s.key === '-')
            }
            else {
                return this.statusKind.find( s => s.key === this.group.messageAIConfirmationHistoryID?.inspectionStatus ) ?? this.statusKind.find(s => s.key === '-')
            }            
        },
        removeKakaoStatus: function() {
            if (this.group.usingCustomAIRemove) {
                return this.statusKind.find( s => s.key === this.group.customMessageAIRemoveHistoryID?.inspectionStatus ) ?? this.statusKind.find(s => s.key === '-')
            }
            else {
                return this.statusKind.find( s => s.key === this.group.messageAIRemoveHistoryID?.inspectionStatus ) ?? this.statusKind.find(s => s.key === '-')
            }
        },
        // 미리보기
        isShowPreview: function() {
            return this.previewType !== null
        },
        previewMessage: function() {
            if (this.previewType === 'create') {
                if (this.group.usingCustomAIImmediateCreate) {
                    return this.group.customMessageAIImmediateCreate
                } else {
                    return this.group.messageAIImmediateCreate
                }
            } else if (this.previewType === 'confirm') {
                if (this.group.usingCustomAIConfirmation) {
                    return this.group.customMessageAIConfirmation
                } else {
                    return this.group.messageAIConfirmation
                }
            } else if (this.previewType === 'remove') {
                if (this.group.usingCustomAIRemove) {
                    return this.group.customMessageAIRemove
                } else {
                    return this.group.messageAIRemove
                }
            }
            return ''
        }
    },
    watch: {
        isShow: {
            handler: function(newValue) {
                if (newValue) {
                    this.group = emptyGroup
                    this.originGroup = emptyGroup
                    this.previewType = null
                    // 수정 확인 상태 초기화
                    this.hasConfirmCreate = false,
                    this.hasConfirmConfirm = false,
                    this.hasConfirmRemove = false,

                    this.loadAiGroup()
                }
            }
        },
    },
    methods: {
        action_Close() {
            this.$emit('close')
        },
        async action_Save() {
            await this.saveAiGroup()
        },
        // 미리보기
        showPreview(type) {
            this.previewType = type
        },
        hidePreview() {
            this.previewType = null
        },
        // 수정 알림 팝업
        handleTextareaFocus(event, type) {
            // 초기값이 '직접 설정'인 경우 textarea focus 시 알림 표시 (한 번만)
            console.log(type)

            if ((this.hasConfirmCreate === false && type === 'create' && this.originGroup.usingCustomAIImmediateCreate === false) ||
                (this.hasConfirmConfirm === false && type === 'confirm' && this.originGroup.usingCustomAIConfirmation === false) ||
                (this.hasConfirmRemove === false && type === 'remove' && this.originGroup.usingCustomAIRemove === false)
            ) {
                event.target.blur()
                this.editAlertTarget = type
                this.isShowEditAlert = true
            }
        },
        hideEditAlert(isConfirm) {
            this.isShowEditAlert = false
            if (isConfirm) {
                // '네' 선택 시 확인 상태 저장
                if (this.editAlertTarget === 'create') {
                    this.hasConfirmCreate = true
                } else if (this.editAlertTarget === 'confirm') {
                    this.hasConfirmConfirm = true
                } else if (this.editAlertTarget === 'remove') {
                    this.hasConfirmRemove = true
                }
            } else {
                // '아니오' 선택 시 기본 설정으로 되돌림
                if (this.editAlertTarget === 'create') { this.group.usingCustomAIImmediateCreate = false }
                if (this.editAlertTarget === 'confirm') { this.group.usingCustomAIConfirmation = false }
                if (this.editAlertTarget === 'remove') { this.group.usingCustomAIRemove = false }
            }
            this.editAlertTarget = null
        },

        // MARK: - Network
        async loadAiGroup() {
            try {
                this.isLoading = true
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작과 동일하게 수렴)
                this.group = await this.queryClient.fetchQuery(reservationGroupAiFindQueryOptions({
                    hospitalID: this.hospital.selectedHospital._id
                }))
                this.originGroup = deepCopy(this.group)
                if (this.group.customMessageAIImmediateCreate === undefined || this.group.customMessageAIImmediateCreate === '') {
                    this.$set(this.group, 'customMessageAIImmediateCreate', this.group.messageAIImmediateCreate)
                }
                if (this.group.customMessageAIConfirmation === undefined || this.group.customMessageAIConfirmation === '') {
                    this.$set(this.group, 'customMessageAIConfirmation', this.group.messageAIConfirmation)
                }
                if (this.group.customMessageAIRemove === undefined || this.group.customMessageAIRemove === '') {
                    this.$set(this.group, 'customMessageAIRemove', this.group.messageAIRemove)
                }
            } catch(err) {
                console.log(err)
            } finally {
                this.isLoading = false
            }
        },

        async saveAiGroup() {
            try {
                await this.mutateAiGroup({
                    _id: this.group._id,
                    hospitalID: this.group.hospitalID,
                    usingCustomAIImmediateCreate: this.group.usingCustomAIImmediateCreate,
                    customMessageAIImmediateCreate: this.group.customMessageAIImmediateCreate,
                    usingCustomAIConfirmation: this.group.usingCustomAIConfirmation,
                    customMessageAIConfirmation: this.group.customMessageAIConfirmation,
                    usingCustomAIRemove: this.group.usingCustomAIRemove,
                    customMessageAIRemove: this.group.customMessageAIRemove
                })
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log('update ai reservation group failed.', err)
                return
            }
            this.action_Close()
        },
    }
}
</script>

<style scoped>
.rsv_msg_wrap {
    display: flex;
    gap: 20px;
}

.msg_edit_table {
    width: 100%;
    border: 1px solid #D6DAE0;
    border-collapse: collapse;
}

.msg_edit_table th {
    height: 28px;
    border-right: 1px solid #D6DAE0;
    border-bottom: 1px solid #D6DAE0;
    background: #F1F3F4;
    font-size: 12px;
    color: #878F9C;
    text-align: center;
}

.msg_edit_table th:last-child {
    border-right: none;
}

.msg_edit_table td {
    padding: 10px;
    border-right: 1px solid #D6DAE0;
    border-bottom: 1px solid #D6DAE0;
    vertical-align: top;
}

.msg_edit_table td:last-child {
    border-right: none;
}

.msg_edit_table tr:last-child td {
    border-bottom: none;
}

.msg_edit_table td.title {
    font-weight: bold;
    vertical-align: middle;
    text-align: center;
}

.rsv_msg_info {
    flex: 1;
}

.radio_wrapper {
    display: flex;
    gap: 16px;
    margin-bottom: 8px;
}

.radio_label {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-size: 13px;
}

.radio_label input[type="radio"] {
    margin: 0;
}

.textarea:disabled {
    background-color: #F5F5F5;
    cursor: not-allowed;
}

.btn_wrap {
    padding-top: 20px !important;
}
</style>
